module.exports = __webpack_public_path__ + "account/assets/down-blue.cdce8bdf.svg";